var windowStatePlugin = {
  install: function (Vue) {
    // ウィンドウの状態
    var state = {
      scrollX: 0,
      scrollY: 0
    }
    // スクロール数値を取得
    var onScroll = function () {
      state.scrollX = window.pageXOffset
      state.scrollY = window.pageYOffset
    }
    document.addEventListener('scroll', onScroll)
    window.addEventListener('load', function () {
      onScroll()
    })
    // プロパティ $window を定義
    Vue.util.defineReactive(Vue.prototype, '$window', state)
  }
}
export default windowStatePlugin



// WEBPACK FOOTER //
// ./src/modules/scrollStatePlugin.js